import { useEffect, useState } from 'react'
import { getSetting, setSetting } from '@services/indexeddb'

export default function DevLocation() {
  const [enabled, setEnabled] = useState(false)
  const [lat, setLat] = useState('')
  const [lon, setLon] = useState('')
  useEffect(() => {
    Promise.all([getSetting('fake_location_enabled'), getSetting('fake_lat'), getSetting('fake_lon')]).then(([en, la, lo]) => {
      setEnabled(!!en)
      setLat(String(la ?? ''))
      setLon(String(lo ?? ''))
    })
  }, [])
  return (
    <div className="bg-white/90 dark:bg-black/90 backdrop-blur-2xl rounded-2xl shadow-2xl p-3 md:p-4 flex flex-col md:flex-row items-center gap-4 md:gap-6 border border-white/50 dark:border-white/10">
      <div className="flex-1 flex items-center gap-4 bg-surface-container-low dark:bg-surface-container-highest px-4 py-2 rounded-xl border border-outline-variant/20 dark:border-outline-variant/10 w-full md:w-auto">
        <span className="material-symbols-outlined text-tertiary">location_on</span>
        <div className="flex flex-col flex-1">
          <span className="text-[10px] uppercase font-bold text-outline tracking-wider">Fake Location</span>
          <div className="flex gap-2 mt-1">
             <input className="w-20 text-sm font-semibold text-on-surface bg-transparent border-none p-0 outline-none" placeholder="Lat" value={lat} onChange={async e => {
                const v = e.target.value
                setLat(v)
                await setSetting('fake_lat', Number(v))
                window.dispatchEvent(new Event('devloc-changed'))
              }} />
             <input className="w-20 text-sm font-semibold text-on-surface bg-transparent border-none p-0 outline-none" placeholder="Lon" value={lon} onChange={async e => {
                const v = e.target.value
                setLon(v)
                await setSetting('fake_lon', Number(v))
                window.dispatchEvent(new Event('devloc-changed'))
              }} />
          </div>
        </div>
      </div>
      <div className="hidden md:block h-10 w-px bg-outline-variant/30"></div>
      <div className="flex items-center gap-3 w-full md:w-auto justify-between md:justify-end">
        <label className="relative inline-flex items-center cursor-pointer">
          <input className="sr-only peer" type="checkbox" checked={enabled} onChange={async e => {
            const v = e.target.checked
            setEnabled(v)
            await setSetting('fake_location_enabled', v)
            window.dispatchEvent(new Event('devloc-changed'))
          }} />
          <div className="w-11 h-6 bg-surface-container-highest peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
          <span className="ml-3 text-sm font-medium text-on-surface-variant">Active</span>
        </label>
        <button className="bg-tertiary text-on-tertiary px-6 py-2.5 rounded-xl text-sm font-bold shadow-lg shadow-tertiary/20 hover:scale-[0.98] transition-all" onClick={async () => {
          await setSetting('fake_location_enabled', true)
          setEnabled(true)
          window.dispatchEvent(new Event('devloc-changed'))
        }}>Update Point</button>
      </div>
    </div>
  )
}
